module.exports = __webpack_public_path__ + "img/25.6b981b2f.png";